// import {isPublicUser} from '@netx/core-user-next/utils/isPublicUser';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';

export const canManageUserSettings = () => {
	return !isBrandPortal(); // !isPublicUser();
};
